import {DestroyRef, inject, Injectable} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {switchMap, tap} from "rxjs";
import {AccountClosedEvent} from "src/app/shared/application/events/account/account-closed.event";
import {EVENT_BUS} from "src/app/shared/domain/tokens/event-bus.token";
import {GetAccountInvoiceUseCase} from "../usecases/get-account-invoice.usecase";
import {TicketEventsService} from "../services/events.service";

@Injectable()
export class GetTicketOnAccountClosedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly getAccountInvoiceUseCase = inject(GetAccountInvoiceUseCase);
  private readonly ticketEventsService = inject(TicketEventsService);

  constructor() {
    this.eventBus.ofType(AccountClosedEvent)
      .pipe(
        switchMap((event) => this.getAccountInvoiceUseCase.execute(event.payload.accountId)),
        tap((ticket) => this.ticketEventsService.emitTicketUpdated(ticket)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
